import { useShoppingCartEffect } from '../../../effects/common/shopping-cart.effect';

export const usePatientOrderSummaryEffect = () => {
  const { cartState, clearCartProductVariant, clearCartTrial } =
    useShoppingCartEffect();

  return {
    cartState,
    clearCartProductVariant,
    clearCartTrial,
  };
};
